import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Grid } from "@mui/material";
import AdminSidebar from "../../../components/Administration/AdminSidebar";
import AddressSettings from "../../../components/Administration/CompanySettings/AddressSettings/index";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    background: "#f3f3f3",
  },
}));

export default function CompanySettings_AddressPage() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2}>
          <AdminSidebar />
        </Grid>
        <Grid item xs={12} md={10}>
          <AddressSettings />
        </Grid>
      </Grid>
    </Box>
  );
}
